



import getPosition from '../helpers/getPosition';
import isMobile from '../helpers/isMobile';
import Lenis from '../helpers/Lenis'

function onReady() {

    if (window.acf) {
        
        //

    }
    else {

        let stopped = false;
        document.addEventListener('site_settings_motion', event => {
            stopped = ('off' === event.detail);
        }, false);
        

        const $bgFade = document.querySelectorAll('[scroll-expand]');
 
        const states = [];
        $bgFade.forEach((el,i) => { 
            el._index = i;
            states.push({el, intersecting: false, i, top: 0, height: 0}) 
        });

        function onResize() {
            $bgFade.forEach(el => {
                states[ el._index ].top    = getPosition(el).top;
                states[ el._index ].height = el.clientHeight;
            });
        }

        function onScroll(scroll) {
            $bgFade.forEach(el => {
                if (isMobile() || stopped) {
                    el.style.maxWidth = '100%';
                    el.style.borderRadius = 0
                }
                else {
                    const docTop = states[el._index].top;  
                    const relTop = docTop - scroll;        
                    let progress = (window.innerHeight / 2 - relTop) / (window.innerHeight / 2);
                    progress = Math.max(0, Math.min(1, progress));
                    el.style.maxWidth     = (80 + progress * 20) + '%';
                    el.style.borderRadius = (6 * (1 - progress)) + 'px';
                }
            });
        }

        Lenis.on('scroll', e => {
            onScroll( e.animatedScroll );
        });

        window.addEventListener('resize',onResize)
        const resizeObserver = new ResizeObserver(e => onResize);
        // Inside the block editor canvas iframe this runs before <body> exists.
        resizeObserver.observe(document.body || document.documentElement);

        $bgFade.forEach(el => {
            resizeObserver.observe(el); 
        });
        
        onResize();
        onScroll(0)

        setTimeout(()=>{
            onResize();
            onScroll(0)
        }, 1000);

    }
}

if (document.readyState === 'complete') {
    onReady()
}
else {
    window.addEventListener("DOMContentLoaded", onReady );
}

export default {}